// extracted by mini-css-extract-plugin
export var hidePc = "FAQSection-module--hide-pc--2AMv_";
export var container = "FAQSection-module--container--2G2kJ";
export var title = "FAQSection-module--title--2V7Ry";
export var content = "FAQSection-module--content--19Xhw";
export var questionBox = "FAQSection-module--questionBox--IJ2HG";
export var questionTitleContainer = "FAQSection-module--questionTitleContainer--3dRDe";
export var questionTitle = "FAQSection-module--questionTitle--PprNf";
export var icon = "FAQSection-module--icon--1EUHg";
export var questionBody = "FAQSection-module--questionBody--2b2vv";